/**
 * @ngdoc directive
 * @name cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
 * @restrict E
 * @description Componente per la ricerca dei clienti su DB Banca e Cerved per
 *              l'apertura di pratiche di Credito Assicurativo
 */
(function() {
  'use strict';
  var CreasRicercaClienteCtrl = function(
    $http,
    $scope,
    $state,
    $stateParams,
    $window,
    $q,
    $httpParamSerializer,
    $uibModal,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    userSrvc,
    dettPraticaSrvc,
    ricercaClienteSrvc
  ) {
    // Setup vars
    var ROTTA_CLIENTE = 'creas-nuova-pratica'; // 'schedaCliente' per
    // landing su brio
    var ROTTA_CLIENTE_CERVED = 'creas-nuova-pratica';
    var COD_PRODOTTO_CERVED = 'CAPMI';
    
    var FORME_COSTITUTIVE_AMMESSE = ['SAA', 'SPA', 'COO', 'ENT', 'SRL', 'SAS', 'SS', 'SDF', 'SNC', 'IND'];

    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$window = $window;
    this.$uibModal = $uibModal;
    this.messaggiFctr = messaggiFctr;
    this.userSrvc = userSrvc;
    this.dettPraticaSrvc = dettPraticaSrvc;
    this.ricercaClienteSrvc = ricercaClienteSrvc;
    $scope.msg = labelSrvc.getLabel;

    /* Spinner */
    this.spinner = {
      listaClientiBanca: false,
      listaClientiCerved: false
    };

    /* Tabella Clienti Banca */
    this.clientiBancaTableLabel = null;
    /* Tabella Clienti Cerved */
    this.clientiCervedTableLabel = null;

    var self = this;
    labelSrvc.labelsPronte.then(
      function(value) {
        self.clientiBancaTableLabel = [
          {
            name: $scope.msg(
              'label.ricercacliente.risultatibanca.intestazione'
            ),
            field: 'intestazione',
            minWidth: 200,
            enableFiltering: true
          },
          {
            name: $scope.msg('label.ricercacliente.risultatibanca.ndg'),
            field: 'ndg',
            minWidth: 100,
            enableFiltering: true
          },
          {
            name: $scope.msg('label.ricercacliente.risultatibanca.datanascita'),
            field: 'dataNascita',
            minWidth: 130,
            enableFiltering: true,
            cellTemplate:
              '<div class="ui-grid-cell-contents">{{row.entity.dataNascita | date: \'dd/MM/yyyy\'}}</div>'
          },
          {
            name: $scope.msg(
              'label.ricercacliente.risultatibanca.naturagiuridica'
            ),
            field: 'naturaGiuridica',
            minWidth: 100,
            enableFiltering: true
          },
          {
            name: $scope.msg(
              'label.ricercacliente.risultatibanca.clienteprospect'
            ),
            field: 'prospetto',
            minWidth: 130,
            enableFiltering: true,
            cellTemplate:
              '<div class="ui-grid-cell-contents">{{row.entity.prospetto === true ? \'Prospetto\' : \'Cliente\'}}</div>'
          },
          {
            name: $scope.msg(
              'label.ricercacliente.risultatibanca.codicefiscale'
            ),
            field: 'codiceFiscale',
            minWidth: 130,
            enableFiltering: true
          },
          {
            name: $scope.msg('label.ricercacliente.risultatibanca.partitaiva'),
            field: 'partitaIva',
            minWidth: 130,
            enableFiltering: true
          },
          {
            name: $scope.msg('label.ricercacliente.risultatibanca.promotore'),
            field: 'nominativoPromotore',
            minWidth: 130,
            enableFiltering: true
          }
        ];

        self.clientiCervedTableLabel = [
			{
				name: $scope.msg('label.ricercacliente.risultaticerved.intestazione'),
				field: 'intestazione',
				minWidth: 200,
				enableFiltering: true
			},
			{
				name: $scope.msg('label.ricercacliente.risultaticerved.indirizzosede'),
				field: 'indirizzoPrincipale',
				minWidth: 130,
				enableFiltering: true,
				cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.indirizzoPrincipale ? row.entity.indirizzoPrincipale.via : "" }}</div>'
			},
			{
				name: $scope.msg('label.ricercacliente.risultaticerved.comune'),
				field: 'indirizzoPrincipale',
				minWidth: 130,
				enableFiltering: true,
				cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.indirizzoPrincipale && row.entity.indirizzoPrincipale.comune ? row.entity.indirizzoPrincipale.comune.codice : "" }}</div>'
			},
			{
				name: $scope.msg('label.ricercacliente.risultaticerved.codicefiscale'),
				field: 'codiceFiscale',
				minWidth: 130,
				enableFiltering: true
            },
            {
				name: $scope.msg('label.ricercacliente.risultaticerved.partitaiva'),
				field: 'partitaIva',
				minWidth: 130,
				enableFiltering: true
            },
			{
				name: $scope.msg('label.ricercacliente.risultaticerved.numerocciaa'),
				field: 'numeroCciaaRea',
				minWidth: 130,
				enableFiltering: true
			},
			{
				name: $scope.msg('label.ricercacliente.risultaticerved.naturagiuridica'),
				field: 'formaCostitutiva',
				minWidth: 100,
				enableFiltering: true
			},
			{
				name: $scope.msg('label.ricercacliente.risultaticerved.attivitaeconomica'),
				field: 'settoreAttivitaEconomica',
				minWidth: 100,
				enableFiltering: true
			},
			{
				name: $scope.msg('label.ricercacliente.risultaticerved.ateco'),
				field: 'ateco',
				minWidth: 100,
				enableFiltering: true
			},
			{
				name: $scope.msg('label.ricercacliente.risultaticerved.datanascita'),
				field: 'dataCostituzione',
				minWidth: 130,
				enableFiltering: true,
				cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.dataNascita | date: \'dd/MM/yyyy\'}}</div>'
			}
        ];
      },
      function(reason) {
        self.clientiBancaTableLabel = [
          {
            name: 'intestazione',
            field: 'intestazione',
            minWidth: 200,
            enableFiltering: true
          },
          {name: 'ndg', field: 'ndg', minWidth: 100, enableFiltering: true},
          {
            name: 'datanascita',
            field: 'dataNascita',
            minWidth: 130,
            enableFiltering: true,
            cellTemplate:
              '<div class="ui-grid-cell-contents">{{row.entity.dataNascita | date: \'dd/MM/yyyy\'}}</div>'
          },
          {
            name: 'naturagiuridica',
            field: 'naturaGiuridica',
            minWidth: 100,
            enableFiltering: true
          },
          {
            name: 'clienteprospect',
            field: 'prospetto',
            minWidth: 130,
            enableFiltering: true,
            cellTemplate:
              '<div class="ui-grid-cell-contents">{{row.entity.prospetto === true ? \'Prospetto\' : \'Cliente\'}}</div>'
          },
          {
            name: 'codicefiscale',
            field: 'codiceFiscale',
            minWidth: 130,
            enableFiltering: true
          },
          {
            name: 'partitaiva',
            field: 'partitaIva',
            minWidth: 130,
            enableFiltering: true
          },
          {
            name: 'promotore',
            field: 'nominativoPromotore',
            minWidth: 130,
            enableFiltering: true
          }
        ];

        self.clientiCervedTableLabel = [
			{
				name: $scope.msg('label.ricercacliente.risultaticerved.intestazione'),
				field: 'intestazione',
				minWidth: 200,
				enableFiltering: true
			},
			{
				name: $scope.msg('label.ricercacliente.risultaticerved.indirizzosede'),
				field: 'indirizzoPrincipale',
				minWidth: 130,
				enableFiltering: true,
				cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.indirizzoPrincipale ? row.entity.indirizzoPrincipale.via : "" }}</div>'
			},
			{
				name: $scope.msg('label.ricercacliente.risultaticerved.comune'),
				field: 'indirizzoPrincipale',
				minWidth: 130,
				enableFiltering: true,
				cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.indirizzoPrincipale && row.entity.indirizzoPrincipale.comune ? row.entity.indirizzoPrincipale.comune.codice : "" }}</div>'
			},
			{
				name: $scope.msg('label.ricercacliente.risultaticerved.codicefiscale'),
				field: 'codiceFiscale',
				minWidth: 130,
				enableFiltering: true
            },
            {
				name: $scope.msg('label.ricercacliente.risultaticerved.partitaiva'),
				field: 'partitaIva',
				minWidth: 130,
				enableFiltering: true
            },
			{
				name: $scope.msg('label.ricercacliente.risultaticerved.numerocciaa'),
				field: 'numeroCciaaRea',
				minWidth: 130,
				enableFiltering: true
			},
			{
				name: $scope.msg('label.ricercacliente.risultaticerved.naturagiuridica'),
				field: 'formaCostitutiva',
				minWidth: 100,
				enableFiltering: true
			},
			{
				name: $scope.msg('label.ricercacliente.risultaticerved.attivitaeconomica'),
				field: 'settoreAttivitaEconomica',
				minWidth: 100,
				enableFiltering: true
			},
			{
				name: $scope.msg('label.ricercacliente.risultaticerved.ateco'),
				field: 'ateco',
				minWidth: 100,
				enableFiltering: true
			},
			{
				name: $scope.msg('label.ricercacliente.risultaticerved.datanascita'),
				field: 'dataCostituzione',
				minWidth: 130,
				enableFiltering: true,
				cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.dataNascita | date: \'dd/MM/yyyy\'}}</div>'
			}
        ];
      }
    );

    /**
		 * @ngdoc method
		 * @name resetSearch
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
		 * @description Permette di ripetere la ricerca del cliente sul DB banca
		 */
    this.resetSearch = function() {
      self.ricercaClienteSrvc.noResultsFlag = false;
      self.ricercaClienteSrvc.ricercaCerved = false;
      self.ricercaClienteSrvc.pivacfisc = null;
      self.ricercaClienteSrvc.clientiBancaTableData = null;
      self.ricercaClienteSrvc.clientiCervedTableData = null;
    };

    /**
		 * @ngdoc method
		 * @name searchParamChanged
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
		 * @description Se il valore del campo di ricerca viene modificato dopo
		 *              la ricerca sul DB Banca, esegue il reset per ripetere la
		 *              ricerca
		 */
    this.searchParamChanged = function() {
      if (self.ricercaClienteSrvc.ricercaCerved === true) {
        self.resetSearch();
      }
    };

    /**
		 * @ngdoc method
		 * @name isSearchDisabled
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
		 * @description Verifica se è possibile eseguire la ricerca in base ai
		 *              filtri inseriti
		 * @return {boolean} - 'false' se la ricerca è avviabile, 'true' se è
		 *         necessario modificare o inserire dati
		 */
    this.isSearchDisabled = function() {
      if (
    		  self.ricercaClienteSrvc.pivacfisc && self.ricercaClienteSrvc.pivacfisc.trim() !== '' &&
    		  (
    				  (self.ricercaClienteSrvc.pivacfisc.trim().length === 11 && /^\d+$/.test(self.ricercaClienteSrvc.pivacfisc.trim())) || self.ricercaClienteSrvc.pivacfisc.trim().length === 16
    		  )
      ) {
        return false;
      }

      return true;
    };

    /**
		 * @ngdoc method
		 * @name isRicercaBancaEnabled
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
		 * @description Verifica se è il pulsante Ricerca Banca è o meno
		 *              visibile
		 * @return {boolean} - 'false' se il pulsante non deve essere
		 *         visualizzato, 'true' se deve essere visualizzato
		 */
    this.isRicercaBancaEnabled = function() {
      return (
        self.ricercaClienteSrvc.ricercaCerved !== true &&
        !(
          self.ricercaClienteSrvc.clientiBancaTableData &&
          self.ricercaClienteSrvc.clientiBancaTableData.length &&
          self.ricercaClienteSrvc.clientiBancaTableData.length > 0
        )
      );
    };

    /**
		 * @ngdoc method
		 * @name isRicercaCervedEnabled
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
		 * @description Verifica se è il pulsante Ricerca Cerved è o meno
		 *              visibile
		 * @return {boolean} - 'false' se il pulsante non deve essere
		 *         visualizzato, 'true' se deve essere visualizzato
		 */
    this.isRicercaCervedEnabled = function() {
      return (
        self.ricercaClienteSrvc.ricercaCerved === true &&
        !(
          self.ricercaClienteSrvc.clientiCervedTableData &&
          self.ricercaClienteSrvc.clientiCervedTableData.length &&
          self.ricercaClienteSrvc.clientiCervedTableData.length > 0
        )
      );
    };
    
    /**
	 * @ngdoc method
	 * @name isRicercaCodiceFiscale
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
	 * @description Verifica in base al termine di ricerca se si sta eseguendo una ricerca di Codice Fiscale
	 * @return {Boolean} - Restituisce true se la ricerca è su un Codice Fiscale, false se è su una Partita IVA
	 */
    this.isRicercaCodiceFiscale = function() {
    	return self.ricercaClienteSrvc.pivacfisc.length > 13;
    }

    /**
		 * @ngdoc method
		 * @name promiseRicercaClientiBanca
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
		 * @description Esegue la chiamata per ottenere i risultati della
		 *              ricerca clienti sul DB Banca
		 * @return {Promise} - Restituisce una promise contenente la ricerca dei
		 *         clienti sul db banca
		 */
    this.promiseRicercaClientiBanca = function(forceDittaInd) {
      var queryParamsObj = {};
      var endpoint = '';

      
      // Verifico se sto eseguendo una ricerca per partita iva o codice fiscale
      if (self.isRicercaCodiceFiscale()) {
    	  endpoint = 'Search/SearchClient';
    	  queryParamsObj = {
	        codiceFiscale: self.ricercaClienteSrvc.pivacfisc,
	        partitaIva: ''
	      };
      } else {
    	  endpoint = 'Search/SearchClient';
    	  queryParamsObj = {
	        codiceFiscale: '',
	        partitaIva: self.ricercaClienteSrvc.pivacfisc
	      };
      }
      
      return this.$http({
        method: 'GET',
        url: CONSTANTS.REST_CLIENTI_ROOT + endpoint,
        params: queryParamsObj
      });
    };

    /**
		 * @ngdoc method
		 * @name promiseRicercaClientiCerved
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
		 * @description Esegue la chiamata per ottenere i risultati della
		 *              ricerca clienti su CERVED
		 * @return {Promise} - Restituisce una promise contenente la ricerca dei
		 *         clienti su CERVED
		 */
    this.promiseRicercaClientiCerved = function() {
      var queryParamsObj = {
        codFiscPiva: self.ricercaClienteSrvc.pivacfisc
      };

      var queryParams = $httpParamSerializer(queryParamsObj);

      return this.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.CLIENTI.RICERCA.CERVED +
          '?' +
          queryParams
      });
    };

    /**
		 * @ngdoc method
		 * @name startSearch
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
		 * @description Avvia la ricerca, verificando se deve essere eseguita
		 *              sul DB Banca o su Cerved
		 */
    this.startSearch = function() {
      if (self.ricercaClienteSrvc.ricercaCerved === true) {
        if (self.isRicercaCervedEnabled() === false) {
          return;
        }

        self.searchClientiCerved();
      } else {
        if (self.isRicercaBancaEnabled() === false) {
          return;
        }

        self.searchClientiBanca();
      }
    };

    /**
		 * @ngdoc method
		 * @name searchClientiBanca
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
		 * @description Avvia la ricerca dei clienti banca in base ai filtri
		 *              inseriti e popola la tabella
		 */
    this.searchClientiBanca = function(forceDittaInd) {
      if (self.isSearchDisabled() !== false) {
        return;
      }

      self.ricercaClienteSrvc.noResultsFlag = false;
      self.spinner.listaClientiBanca = true;

      $q
        .all({
          ricercaClientiBanca: self.promiseRicercaClientiBanca(forceDittaInd)
        })
        .then(
          function(response) {
        	if (
              self.messaggiFctr.processaResponse(response.ricercaClientiBanca)
            ) {
              self.ricercaClienteSrvc.noResultsFlag = false;
              self.ricercaClienteSrvc.clientiBancaTableData = null;
              self.spinner.listaClientiBanca = false;
              return;
            }
            
            if (response.ricercaClientiBanca.data.length === 0) {
            	if(!self.isRicercaCodiceFiscale() && !forceDittaInd){
            		self.searchClientiBanca(true);
            		return;
            	}else{
	                self.ricercaClienteSrvc.clientiBancaTableData = null;
	                self.ricercaClienteSrvc.noResultsFlag = true;
	                self.ricercaClienteSrvc.ricercaCerved = true;
	                self.spinner.listaClientiBanca = false;
	                return;
            	}
            }
            self.spinner.listaClientiBanca = false;
            self.ricercaClienteSrvc.noResultsFlag = false;
            self.ricercaClienteSrvc.clientiBancaTableData =
              response.ricercaClientiBanca.data;
            
          },
          function(reason) {
            self.messaggiFctr.processaResponse(reason.ricercaClientiBanca);
            self.ricercaClienteSrvc.clientiBancaTableData = null;
            self.spinner.listaClientiBanca = false;
          }
        );
    };

    /**
		 * @ngdoc method
		 * @name searchClientiCerved
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
		 * @description Avvia la ricerca su cerved in base ai filtri inseriti e
		 *              popola la tabella
		 */
    this.searchClientiCerved = function() {
      if (self.isSearchDisabled() !== false) {
        return;
      }
      
      // Richiedo conferma prima di proseguire con la ricerca
      var modalController = function($scope, LabelSrvc, $modalInstance) {
	      $scope.headerText = LabelSrvc.getLabel(
	        'label.ricercacliente.confermacerved.header'
	      );
	      $scope.bodyText = LabelSrvc.getLabel(
	        'label.ricercacliente.confermacerved.content'
	      ) + ' ' + self.ricercaClienteSrvc.pivacfisc;
	      $scope.cancelText = LabelSrvc.getLabel(
	        'label.ricercacliente.confermacerved.cancel'
	      );
	      $scope.confirmText = LabelSrvc.getLabel(
	        'label.ricercacliente.confermacerved.confirm'
	      );
	
	      $scope.optionSelected = function(result) {
	        $modalInstance.close(result);
	      };
	    };
	
	    modalController.$inject = ['$scope', 'LabelSrvc', '$modalInstance'];
	
	    var modalInstance = this.$uibModal.open({
	      animation: true,
	      template:
	        '<creas-confirm-modal header-text="headerText" body-text="bodyText" cancel-text="cancelText" confirm-text="confirmText" option-selected="optionSelected(result)"></creas-confirm-modal>',
	      backdrop: 'static',
	      size: 'lg',
	      controller: modalController
	    });
	
	    modalInstance.result.then(function(confirmResult) {
	      if (confirmResult !== true) {
	        return;
	      }
	
	      // Eseguo la ricerca su Cerved
	      self.ricercaClienteSrvc.noResultsFlag = false;
	      self.spinner.listaClientiCerved = true;

	      $q
	        .all({
	          ricercaClientiCerved: self.promiseRicercaClientiCerved()
	        })
	        .then(
	          function(response) {
	            // Verifico se tra gli errori ho quello che indica che il
	            // cliente non è stato trovato
	            var hasErroreNoCliente = false;
	            
	            if (response.ricercaClientiCerved.data.messageList) {
	            	angular.forEach(
	                    response.ricercaClientiCerved.data.messageList.errMessages,
	                    function(value) {
	                      if (hasErroreNoCliente === true) {
	                        return;
	                      }

	                      switch (value.message) {
	                        case 'NOPF':
	                        case 'NOPG':
	                          hasErroreNoCliente = true;
	                          break;
	                      }
	                    }
	                  );
	            }
	            
	            if (hasErroreNoCliente === true) {
	              self.ricercaClienteSrvc.clientiCervedTableData = [];
	              self.ricercaClienteSrvc.noResultsFlag = true;
	              return;
	            }

	            if (
	              self.messaggiFctr.processaResponse(
	                response.ricercaClientiCerved
	              ) !== false
	            ) {
	              self.ricercaClienteSrvc.noResultsFlag = false;
	              self.ricercaClienteSrvc.clientiCervedTableData = null;
	              return;
	            }

	            self.ricercaClienteSrvc.noResultsFlag = false;
	            self.ricercaClienteSrvc.clientiCervedTableData = [
	              response.ricercaClientiCerved.data.result
	            ];
	          },
	          function(reason) {
	            self.messaggiFctr.processaResponse(reason.ricercaClientiCerved);
	            self.ricercaClienteSrvc.clientiCervedTableData = null;
	          }
	        )
	        .finally(function() {
	          self.spinner.listaClientiCerved = false;
	        });
	    });

    };

    /**
		 * @ngdoc method
		 * @name hasRisultatiClientiBanca
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
		 * @description Verifica se la ricerca clienti banca ha restituito
		 *              risultati
		 * @return {boolean} - true se ho almeno un risultato, false se non sono
		 *         presenti risultati
		 */
    this.hasRisultatiClientiBanca = function() {
      return (
        self.ricercaClienteSrvc.clientiBancaTableData.length &&
        self.ricercaClienteSrvc.clientiBancaTableData.length > 0
      );
    };
    
    /**
	 * @ngdoc method
	 * @name formaCostitutivaValida
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
	 * @description Verifica che la forma costitutiva del cliente sia compatibile per l'apertura di una pratica di credito assicurativo
	 * @param {Object} cliente - i dati del cliente
	 * @return {boolean} - true se la forma costitutiva è ammesse, false se non è compresa tra quelle consentite
	 */
    this.formaCostitutivaValida = function(cliente) {
    	if (cliente.naturaGiuridica) {    		
    		return FORME_COSTITUTIVE_AMMESSE.indexOf(cliente.naturaGiuridica.toUpperCase()) > -1;
    	} else if (cliente.formaCostitutiva) {
    		return FORME_COSTITUTIVE_AMMESSE.indexOf(cliente.formaCostitutiva.toUpperCase()) > -1;
    	}
    }

    /**
		 * @ngdoc method
		 * @name openCliente
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
		 * @description Apre la scheda del cliente selezionato
		 * @param {Object}
		 *            row - Oggetto contenente i dati del cliente selezionato
		 */
    this.openCliente = function(row) {
    	
      if (self.formaCostitutivaValida(row) !== true) {
    	  self.messaggiFctr.addMessage({ type: 'W', message: $scope.msg('label.ricercacliente.alert.naturagiuridica') });
    	  return;
      }
      
      if (row.praticaVariazione) {
    	  self.messaggiFctr.addMessage({ type: 'W', message: $scope.msg('label.ricercacliente.alert.variazione').replace("[INTESTAZIONE]",row.intestazione) });
    	  return;
      }
      if (row.naturaGiuridica === 'PRV') {
    	  self.messaggiFctr.addMessage({ type: 'W', message: $scope.msg('label.ricercacliente.alert.prv').replace("[INTESTAZIONE]",row.intestazione) });
    	  return;
      }
      
      self.dettPraticaSrvc.reset();
      self.dettPraticaSrvc.datiClienteBanca = row;
      var params = self.$stateParams;
      params.ndg = row.ndg;
      params.codProdotto = COD_PRODOTTO_CERVED;
      params.idAnagrafica = row.idAnagrafica;

      self.$state.go(ROTTA_CLIENTE, params);
    };

    /**
		 * @ngdoc method
		 * @name openClienteCerved
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRicercaCliente
		 * @description Apre la procedura di creazione pratica per il cliente
		 *              Cerved Selezionato
		 * @param {Object}
		 *            row - Oggetto contenente i dati del cliente Cerved
		 *            selezionato
		 */
    this.openClienteCerved = function(row) {
    	
      if (self.formaCostitutivaValida(row) !== true) {
      	  self.messaggiFctr.addMessage({ type: 'W', message: $scope.msg('label.ricercacliente.alert.naturagiuridica') });
      	  return;
      }
    	
      self.dettPraticaSrvc.reset();
      self.dettPraticaSrvc.datiClienteCerved = row;
      self.spinner.listaClientiCerved = true;
      this.$http({
        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.CLIENTI.CREA_DA_CERVED,
        params: {
          codFiscPiva: self.ricercaClienteSrvc.pivacfisc
        },
        method: 'GET'
      })
        .then(
          function(response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }
            var params = self.$stateParams;
            params.ndg = response.data.result.ndg;
            params.codProdotto = COD_PRODOTTO_CERVED;
            self.$state.go(ROTTA_CLIENTE_CERVED, params);
          },
          function(reason) {
            self.messaggiFctr.processaResponse(reason);
          }
        )
        .finally(function() {
          self.spinner.listaClientiCerved = false;
        });
    };

    this.userSrvc.abilitazioniPronte.then(function(result) {
    	//Verifico se vengo da un punto dove voglio preservare la ricerca
       if(self.ricercaClienteSrvc.preserveSearch){
    	   self.ricercaClienteSrvc.preserveSearch = false;
       } else {
    	   self.resetSearch();
       }
       
    	
      // Verifico se Credito assicurativo è abilitato
      // in caso contrario rimando alla home
      for (var i = 0; i < self.userSrvc.abilitazioni.length; i++) {
        if (
          self.userSrvc.abilitazioni[i].codice ===
          'CreditoAssicurativoPMIAbilitato'
        ) {
          return;
        }
      }

      self.$state.go('schedaCliente');
    });
  };

  CreasRicercaClienteCtrl.$inject = [
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$window',
    '$q',
    '$httpParamSerializer',
    '$uibModal',
    'CONSTANTS',
    'LabelSrvc',
    'CreasMessaggiFctr',
    'UserSrvc',
    'CreasDettaglioPraticaSrvc',
    'CreasRicercaClienteSrvc'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'creasRicercaCliente/creasRicercaCliente.html'
    );
  };

  TemplateUrl.$inject = ['CONSTANTS'];

  var CreasRicercaClienteComponent = {
    controller: CreasRicercaClienteCtrl,
    controllerAs: 'creasRicercaClienteCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.insuranceloanpmi.mf')
    .component('creasRicercaCliente', CreasRicercaClienteComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/creasRicercaCliente/creasRicercaCliente.cmpt.js
// module id = 13
// module chunks = 0 1